import { __rest } from '../../_virtual/_tslib.js';
import React__default from 'react';
import classNames from 'classnames';
import Styles from './ResponsiveContainer.module.scss.js';

const ResponsiveContainer = (_a) => {
    var { className, id } = _a, props = __rest(_a, ["className", "id"]);
    return (React__default.createElement("div", { id: id, className: classNames(Styles.container_box, className) }, props.children));
};

export { ResponsiveContainer as default };
//# sourceMappingURL=ResponsiveContainer.js.map
